var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIconRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0022 21.1451C17.0517 21.1451 21.1451 17.0517 21.1451 12.0022C21.1451 6.95277 17.0517 2.85938 12.0022 2.85938C6.95277 2.85938 2.85938 6.95277 2.85938 12.0022C2.85938 17.0517 6.95277 21.1451 12.0022 21.1451Z",
    stroke: "#39ACE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0034 13.5456C12.675 13.5456 13.3465 12.8741 13.3465 12.2025C13.3465 11.5309 12.675 10.8594 12.0034 10.8594C11.3318 10.8594 10.6616 11.5309 10.6616 12.2025C10.6616 12.8741 11.3318 13.5456 12.0034 13.5456ZM6.63085 13.5456C7.30242 13.5456 7.97399 12.8741 7.97399 12.2025C7.97399 11.5309 7.30242 10.8594 6.63085 10.8594C5.95929 10.8594 5.28906 11.5309 5.28906 12.2025C5.28906 12.8741 5.95929 13.5456 6.63085 13.5456ZM17.3759 13.5456C18.0475 13.5456 18.7191 12.8741 18.7191 12.2025C18.7191 11.5309 18.0475 10.8594 17.3759 10.8594C16.7044 10.8594 16.0341 11.5309 16.0341 12.2025C16.0341 12.8741 16.7044 13.5456 17.3759 13.5456Z",
    fill: "#39ACE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIconRounded);
export default __webpack_public_path__ + "static/media/MoreIconRounded.2d57a1a732f19537939679c23f66a58f.svg";
export { ForwardRef as ReactComponent };